// extracted by mini-css-extract-plugin
module.exports = {"container":"desktopView_container__30lmH","sideContent":"desktopView_sideContent__2BRSf","mainContent":"desktopView_mainContent__1PU-I","copyright":"desktopView_copyright__6g7aj"};